export default [
  {
    id: `material`,
    title: `Торт банановый`,
    content: {
      description: `<p>Состав: мука пш./вс, сахар, яйцо куриное, бананы свежие, крем ковер покрытие, сливки, масло, шоколад белый, молоко, вафельная крошка, физалес свежий, свежие ягоды.</p><p>Содержание в 100г: белки 15г, жиры 18г, углеводы 37г.<br/>Энергетическая ценность в 100г 300ккал</p><p>Прямая печать на шоколаде.</p>`
    }
  },
  {
    id: `printing`,
    title: `Способ печати`,
    content: {
      printingInfo: `<p>Прямая печать на шоколаде.</p>`
    }
  },
  {
    id: `price`,
    title: `Цены`
  },
  {
    id: `delivery`,
    title: `Доставка и оплата`
  },
  {
    id: `reviews`,
    title: `Отзывы`
  }
];
